import { render } from "./icon-key.vue?vue&type=template&id=7e71bc2c"
import script from "./icon-key.vue?vue&type=script&lang=js"
export * from "./icon-key.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__